import styled from 'styled-components';

export const ZillowNavbarSubSectionLinksListGroup = styled.ul`
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
`;
